import React from 'react';
import { ModalHeader } from '../modal-header/ModalHeader';
import type { BookingPurchaseDialogData } from './BookingPurchaseDialog.types';
import { MainView } from './main-view/MainView';
import { ResponseView, ScaPendingView } from './response-view/ResponseView';

type Props = {
  data: BookingPurchaseDialogData;
};

function DialogHeader({ header }: { header?: BookingPurchaseDialogData['header'] }) {
  if (!header) {
    return null;
  }

  return <ModalHeader data={header} />;
}

function DialogView({ data }: Props) {
  switch (data.view) {
    case 'success':
      return <ResponseView data={data} iconClass="icon-success icon-confirmation" />;
    case 'error':
      return <ResponseView data={data} iconClass="icon-error icon-circled-x" />;
    case 'sca-pending':
      return <ScaPendingView data={data} />;
    default:
      return <MainView data={data} />;
  }
}

export function BookingPurchaseDialog({ data }: Props) {
  if (!data?.unifiedDialogEnabled) {
    return null;
  }

  return (
    <>
      <DialogHeader header={data.header} />
      <DialogView data={data} />
    </>
  );
}
